<template>
  <div v-if="price || limitPrice">
    <div v-if="type === '2'">
      <div :class="{'add-top': true,'common-font-style': true,'white-style': fontType === 'detail'}" v-if="price">
        <span v-if="showSymbolIcon === 'Y'" :class="{'white-style':fontType === 'detail','add-fuhao':fontType !== 'detail'}"> &#65509; </span>
        <span>{{ getShowPrice((price || 0)- (limitPrice || 0)) }}</span>
        <span class="limit-price" v-if="limitPrice > 0">
          <span :class="{'fuhao-add': true, 'white-font':fontType === 'detail'}">+</span>
          <img class="sale-price-icon" :src="unionIcon" alt="fudou" />
          <span class="add-price">{{ getShowPrice(limitPrice) }}</span> 
        </span>
      </div>
    </div>
    <div :class="{'common-font-style': true,'money-part': true}" v-else>
      <span :class="{'white-style': fontType === 'detail' }">{{showSymbolIcon==='Y'?`&#65509;${ getShowPrice(price || 0)}`: `${getShowPrice(price || 0)}` }}</span>
      <div v-if="limitPrice > 0" :class="{'money-decu':true, 'detail-style': fontType === 'detail'}">{{ `福豆可抵${getShowPrice(limitPrice || 0)}${showSymbolIcon==='Y'?'元':''}` }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      require: true,
    },
    price: {
      type: Number,
      required: true,
    },
    limitPrice: {
      type: Number,
      // required: true,
    },

    showSymbolIcon: {
      type: Boolean,
      default: true,
    },

    unionIcon: {
      required: true,
    },
    fontType: {
      type: String,
    },
    showDecimal:{
      type: Boolean,
      default: false,
    },

  },
  data() {
    return {
      unionScale: window.union_scale,
    };
  },

  methods: {
    getShowPrice(price ) {
      const _scale = window.union_scale || 1;
      if ( this.showDecimal ) {
        return (price * _scale).toFixed(2) || 0.00;
      }
      return parseFloat((price * _scale).toFixed(2) || 0);
    },
  },
};
</script>
<style scoped>
.labels {
  display: flex;
}
.label-img {
  width: 32px;
  height: 16px;
}
.prom-price {
  font-size: 14px;
  color: #f44545;
}
.large-font {
  font-size: 19px;
}
.origin-price {
  font-size: 12px;
  color: #999;
  position: relative;
}
.origin-price:after {
  content: '';
  width: 100%;
  height: 1px;
  background: #999;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(-50%, 0);
  transform: scaleY(0.5);
}
.price-icon {
  /* width: 12px;
    height: 12px; */
  width: 12px;
  height: 12px;
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
  opacity: 0.7;
  /* vertical-align: bottom; */
  vertical-align: baseline;
}
.sale-price-icon {
  width: 16px;
  height: 16px;
}
.add-top {
  display: flex;
  align-items: center;
}

.add-fuhao{
  font-size: 18px;
}
.fuhao-add{
  color: #999999;
  position: relative;
  top: -1px;
}
.money-part{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.money-decu{
  background: #FF5757;
  border-radius: 8px;
  height: 16px;
  line-height: 16px;
  padding: 0 4px;
  margin-left: 4px;
  color: white;
  font-size: 12px;
  font-weight: 400;
}
.limit-price{
  display: flex;
  align-items: baseline;
  justify-content: center;
}
.white-style{
  color: white !important;
  font-size: 30px !important;
  font-weight: 700;
}
.detail-style{
  color: #FF5757;
  background: white;
  font-weight: 500;
}
.white-font{
  color: white !important;
  font-size: 16px;
}
.common-font-style{
  font-size: 20px;
  color: #FF5757;
}
</style>
